import { useState } from 'react';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { useParams } from 'react-router-dom';
import { PageInfoHeading } from '@/components/Header/Page/PageInfoHeading';
import {
  useGetAllVehiculeChecks,
} from '@/hooks/vehicule-check.hooks';
import { InspectionUsageTableView } from '../components/InspectionUsageTableView';
import { TVehiculeCheckSchema } from '@/schemas/vehicule-check/vehicule-check.schema';
import { InspectionUsageTableHeaders } from '../components/InspectionUsageTableHeaders';
import { InspectionUsageTableData } from '../components/InspectionUsageTableData';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import {
  InspectionProgressStatusUpdatePayload,
  useSocket,
} from '@/hooks/socket.hooks';

export const InspectionUsageListPage = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('inspection');
  const { vehiculeId } = useParams();
  const [totalActive, setTotalActive] = useState<number>(0);

  const onGetTotalActive = (total: number) => {
    setTotalActive(total);
  };

  useSocket({
    onInspectionProgressStatusUpdate: (
      data: InspectionProgressStatusUpdatePayload
    ) => {
      queryClient.invalidateQueries({ queryKey: ['getAllVehiculeChecks'] });

      console.warn('inspectionProgressStatusUpdate', data);
    },
  });

  return (
    <>
      <PageHeader
        backToLink={vehiculeId ? -1 : undefined}
        title={t('common:inspectionUsage')}
        totalItems={totalActive}
        headingElement={
          <PageInfoHeading
            text={t('common:detailsRelatedToCurrentSection')}
          />
        }
      />
      <div>
        <InspectionUsageTableView<TVehiculeCheckSchema>
          t={t}
          useGetAllData={useGetAllVehiculeChecks}
          onGetTotalActive={onGetTotalActive}
          tableHeaders={InspectionUsageTableHeaders}
          tableData={InspectionUsageTableData}
          canSelectItems={false}
        />
      </div>
    </>
  );
};
